// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3gQ3N","label":"Category_label__39EwQ","content":"Category_content__2qTzA","header":"Category_header__1NrW7","location":"Category_location__1TJhv"};